import React from 'react';
import './ListOfVersions.scss';
import HeaderPrint from "../HeaderPrint/HeaderPrint";
import ListVersionsTable from "./ListVersionsTable";

const ListOfVersions = ({data}) => {

  return (
    <>
      {data?.data?.data.map((item, index) => (
        <React.Fragment key={index}>
          <section className='list_of_versions'>
            <HeaderPrint
              englishTitle={"List  of  versions"}
              persianTitle={"فهرست ورژن ها"}
              color={"#86B412"}
            />
            <div className='form_info'>
              <div className='info_box'>
                <div className='box_child'>
                  <span className='iransans'>کاربـر :</span>
                  <span className='iransans'>{item.user}</span>
                </div>
              </div>
              <div className='info_box'>
                <div className='box_child'>
                  <span className='iransans'>تاریخ :</span>
                  <span className='iransans'>{item.date}</span>
                </div>
              </div>
            </div>
            <ListVersionsTable tableData={item.table}/>
          </section>
          {index < data?.data?.data.length - 1 && (
            <div style={{pageBreakBefore: "always"}}></div>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default ListOfVersions;